//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CashAttachmentDisplayItem } from './CashAttachmentDisplayItem';
import { AttendanceDisplayItem } from './AttendanceDisplayItem';
import { EventCategoryDisplayItem } from './EventCategoryDisplayItem';
import { TaxDisplayItem } from './TaxDisplayItem';
import { PayrollType, PayrollSourceType } from './Enums';

export class PayrollDisplayItem extends ItemBase {
    Amount: number = 0;
    Accrued: boolean = false;
    CashCategoryID: string | null = null;
    ID: string | null = null;
    TeacherID: string | null = null;
    EventID: string | null = null;
    EventCategoryID: string | null = null;
    PayrollType: PayrollType = PayrollType.Income;
    Date: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    HasAttachments: boolean = false;
    DisplayDescription: string | null = null;
    Comment: string | null = null;
    Source: PayrollSourceType = PayrollSourceType.Manual;
    Income: number | null = null;
    ManualAdjustmentRequired: boolean = false;
    ManualAdjustmentDone: boolean = false;
    Payment: number | null = null;
    Balance: number | null = null;
    CanEdit: boolean = false;
    CanDelete: boolean = false;
    IsSubstitutePay: boolean = false;
    IsFixedMonthlyPayroll: boolean = false;
    PaymentMethod: string | null = null;
    Attachments: CashAttachmentDisplayItem[] = [];
    Attendances: AttendanceDisplayItem[] = [];
    EventCategory: EventCategoryDisplayItem | null = null;
    Taxes: TaxDisplayItem[] = [];

    constructor(initializer?: Partial<PayrollDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayrollDisplayItem";
}
